import { field } from "./styles";

export const blankHandoff = { summary: "", current_goal: "", important_context: "", decisions: "", open_questions: "", next_actions: "", related_documents: "" };
export const handoffPayload = (title, values) => ({ title, ...values,
  ...Object.fromEntries(["decisions", "open_questions", "next_actions", "related_documents"].map(k => [k, values[k].split("\n").map(s => s.trim()).filter(Boolean)])) });

export const HandoffFields = ({ value, onChange }) => <div className="space-y-3">
  {Object.keys(blankHandoff).map(key => <label className="block text-xs text-[var(--aria-text-muted)]" key={key}>
    {key.replaceAll("_", " ")}{["decisions", "open_questions", "next_actions", "related_documents"].includes(key) ? " (one per line)" : ""}
    <textarea className={`${field} mt-1`} rows={key === "summary" || key === "important_context" ? 4 : 2}
      value={value[key]} required={key === "summary"} maxLength={key === "important_context" ? 12000 : 6000}
      data-testid={`handoff-${key.replaceAll("_", "-")}`} onChange={e => onChange({ ...value, [key]: e.target.value })} />
  </label>)}
</div>;